import "antd/dist/antd.variable.min.css";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import Script from "next/script";
import React from "react";
// import "styles/ant.scss";
// import "styles/base.scss";
import "styles/globals.scss";
// import "styles/root.scss";
import "utils/prototype";

// import "@tools/styles/src/base.css"
// import "@tools/styles/src/ju-ant.scss";
// import "@tools/styles/src/ju.scss";
// import renderList from "@tools/Nav/src/web-components/ssr";
import "@tools/styles/src/iconfont.css"
import '@ju/styles'
import '@ju/antd-ui/dist/es/styles/src/index.css';
import "@tools/styles/src/root.css";
// ⚡ 神策SDK改为动态导入，避免阻塞首屏
// import sensors from "@tools/sensors";
import { getFingerprint } from '@ju/fingerprint';

import Storage from "utils/storage";
import { Context as JuContext, Cookie, Hooks, Request, Locale } from "@tools/base";
import { ConfigProvider } from "antd";
import useWindowResize from "hooks/useWindowResize";
import store from "store";
import { BreakpointEnum, ThemeEnum } from "store/app";
import type { LangMessages } from "@/locales/loadLocaleMessages";
import { loadLocaleMessages } from "@/locales/loadLocaleMessages";
import NextApp from "next/app";
const cdnConfig = require("@tools/base/src/cdn.config");
const { Context, Provider } = JuContext;
import webRum from "@/utils/web-rum";
import { safeRequestIdleCallback, safeCancelIdleCallback } from "@/utils/requestIdleCallback";
const { useInviteCode } = Hooks;

const Package: any = require("../../package.json"); // eslint-disable-line

interface ContextState {
  theme?: string;
  currency?: string;
  colorReverse?: number;
}

const Content = ({ theme, children }) => {
  const router = useRouter();
  const [appState, appDispatch] = React.useContext<any>(Context);
  React.useEffect(() => {
    const payload: ContextState = {};
    const payloadTheme = Cookie.get("theme") || theme || "light";
    if (/^(dark|light)$/.test(payloadTheme)) {
      payload.theme = payloadTheme;
    }
    const currency = Cookie.get("currency");
    currency && (payload.currency = currency);
    appDispatch({ payload });
    const colorReverse = Cookie.get("colorReverse") || Storage.get("colorReverse");
    payload.colorReverse = +colorReverse || 0;

    //clientCode
    let clientCode = Cookie.get("clientCode");
    if (!clientCode || clientCode.length !== 32) {
      clientCode = Date.now() + generateNonceStr(19);
      Cookie.set("clientCode", clientCode);
    }

    Request.setHeader({ "client-code": clientCode });
    //antd

    // message.config({ top: 60 });
    ConfigProvider.config({ theme: { primaryColor: "#16B8F3" } });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {

    const isLogin = appState.loginStatus === 1;
    const token = isLogin ? Cookie.get("token") : "";

    store.app.updateState({
      theme: appState.theme as ThemeEnum,
      colorStyle: appState.colorReverse,
    });
    store.balances.updateState({
      convertCurrency: appState.currency,
    });
    store.user.updateState({
      isLogin,
      token,
      userInfo: appState.userInfo,
    });

    console.log("%c【appState】", "color:#00aecc", appState);
  }, [appState]);

  React.useEffect(() => {
    if (process.env.NEXT_PUBLIC_LOCAL && router.query.token) {
      Cookie.set("token", router.query.token as string);
      router.replace("/equity/" + router.query.symbol);
    }
  }, [router]);

  return children;
};

function App({ Component, pageProps }: AppProps) {
  (reportWebVitals as any).nextRouterInfo = useRouter(); // 用于性能埋点绑定路由
  const { locale = "en", locales = [] } = useRouter();


  // 根据环境变量确定GTM ID
  const isProduction = process?.env?.NEXT_PUBLIC_ENV === 'pro';
  const gtmId = isProduction ? 'GTM-PM7K2HH2' : 'GTM-555TGFBV';

  const langMessages = (pageProps as any).langMessages as LangMessages || {};
  Locale.init(locale, locales, langMessages);
  const localeObj = Locale.getLocaleObj(locale);

  const payload = { lang: localeObj.key, tenant: "jcwork", litHtml: pageProps.litHtml };
  // Cookie.set("lang", locale == "zh-CN" ? "cn" : locale == "zh-HK" ? "hk" : locale);
  Cookie.set("lang",
    locale === "zh-CN" ? "cn" :
      locale === "zh-HK" ? "hk" :
        locale === "id" ? "in" :
          locale
  );
  // console.log("%c【App props】", "color:#00aecc", pageProps);

  const domain = !process.env.NEXT_PUBLIC_LOCAL ? process.env.NEXT_PUBLIC_cdn + "/public" : "";
  const wsPreconnectOrigin = (typeof window === 'undefined' ? 'https:' : (window.location.protocol.startsWith('https') ? 'https:' : 'http:')) +
    '//' + 'fws.' + ((process?.env?.NEXT_PUBLIC_host || '').split('.').slice(-2).join('.'));
  const sensorsOrigin = 'https://web.webstatic.cc';

  if (process.env.NEXT_PUBLIC_LOCAL) {
    Request.setHeader({ "X-Forwarded-Host": process.env.NEXT_PUBLIC_host });
  }

    // 初始化设备指纹
    React.useEffect(() => {
      const initFingerprint = async () => {
        try {
          const fingerToken = await getFingerprint();
          if (fingerToken) {
            Request.setHeader({ "X-FINGER-TOKEN": fingerToken });
           }
        } catch (error) {
          console.error("Failed to initialize fingerprint:", error);
        }
      };

      initFingerprint();
    }, []);


  useWindowResize(() => {
    let breakpoint;
    const { innerWidth, outerWidth } = window;
    if (innerWidth >= 1698) {
      breakpoint = BreakpointEnum.xl;
    } else if (innerWidth > 1200) {
      breakpoint = BreakpointEnum.lg;
    } else if (innerWidth > 768) {
      breakpoint = BreakpointEnum.md;
    } else {
      breakpoint = BreakpointEnum.sm; //<= 768
    }

    // if (outerWidth < 768) breakpoint = BreakpointEnum.sm;

    // alert(breakpoint);
    store.app.updateState({ breakpoint, windowInnerWidth: innerWidth });
    document.body.setAttribute("data-breakpoint", breakpoint);
  });

  // 神策埋点初始化：动态引入 + useEffect，避免阻塞首屏绘制
  React.useEffect(() => {
    let initialized = false;

    const init = async () => {
      // 检查神策SDK是否已加载（全局变量 sensorsDataAnalytic201505 是神策SDK的标志）
      if (initialized || !(window as any).sensorsDataAnalytic201505) {
        console.log('神策SDK检查:', {
          initialized,
          sdkLoaded: !!(window as any).sensorsDataAnalytic201505
        });
        return;
      }
      initialized = true;

      try {
        // 动态导入神策模块，不阻塞首屏
        const sensors = (await import('@tools/sensors')).default;
        sensors.init({
          env: process.env.NEXT_PUBLIC_ENV || 'dev',
          version: Package.version,
          is_login: !!Cookie.get('token'),
          language_type: localeObj.key,
        });
        console.log('神策初始化成功');
      } catch (e) {
        console.error('神策SDK初始化失败:', e);
        initialized = false;
      }
    };

    if (typeof window === 'undefined') return;

    // 监听神策脚本加载完成事件
    window.addEventListener('sensorsScriptLoaded', init);
    
    // 如果SDK已加载，立即初始化
    if ((window as any).sensorsDataAnalytic201505) {
      init();
    } else {
      // 否则延迟初始化，给SDK加载留出时间
      const timer = safeRequestIdleCallback(init, { timeout: 3000 });
      
      return () => {
        window.removeEventListener('sensorsScriptLoaded', init);
        safeCancelIdleCallback(timer);
      };
    }

    return () => window.removeEventListener('sensorsScriptLoaded', init);
  }, []);

  React.useEffect(() => {
    // 初始化全链路监控
    webRum();
    
    // 延迟注册 Service Worker - 首屏后再注册
    if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      const registerSW = () => {
        navigator.serviceWorker.register('/sw.js')
          .then((registration) => {
            console.log('SW registered: ', registration);
          })
          .catch((registrationError) => {
            console.log('SW registration failed: ', registrationError);
          });
      };

      // 等待页面加载完成且空闲时再注册
      safeRequestIdleCallback(registerSW, { timeout: 5000 });
    }
  }, [])

  React.useEffect(() => {
    // 延迟插入GTM noscript iframe
    const insertGTM = () => {
      const noscriptElement = document.createElement('noscript');
      const iframeElement = document.createElement('iframe');
      iframeElement.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
      iframeElement.height = "0";
      iframeElement.width = "0";
      iframeElement.style.display = "none";
      iframeElement.style.visibility = "hidden";
      noscriptElement.appendChild(iframeElement);
      
      if (document.body.firstChild) {
        document.body.insertBefore(noscriptElement, document.body.firstChild);
      } else {
        document.body.appendChild(noscriptElement);
      }
    };

    // 空闲时插入，不影响首屏
    safeRequestIdleCallback(insertGTM, { timeout: 3000 });
  }, []);

  React.useEffect(() => {
    store.app.updateState({ clientSideReady: true });
    console.log("%c【App client side ready】", "color:#52c41a", store);
  }, []);

  useInviteCode()

  return (
    <Provider payload={payload} intlValue={Locale.intl}>
      <ConfigProvider locale={pageProps.antd} autoInsertSpaceInButton={false}>
        <Head>
          <meta name="version" content={`${Package.version}`} key="version" />
          {process.env.NEXT_PUBLIC_cdn ? (
            <>
              <link rel="preconnect" href={process.env.NEXT_PUBLIC_cdn as any} crossOrigin="" />
              <link rel="dns-prefetch" href={process.env.NEXT_PUBLIC_cdn as any} />
            </>
          ) : null}
          <link rel="preconnect" href={wsPreconnectOrigin as any} crossOrigin="" />
          <link rel="dns-prefetch" href={wsPreconnectOrigin as any} />
          <link rel="preconnect" href={sensorsOrigin as any} />
          <link rel="dns-prefetch" href={sensorsOrigin as any} />
          <link rel="preconnect" href="https://www.googletagmanager.com" />
          <link rel="preconnect" href="https://www.google-analytics.com" />
          {/* 预加载关键脚本 */}
          <link 
            rel="preload" 
            as="script" 
            href={domain + "/beforeInteractive.js?v=" + Package.version}
          />
        </Head>
        {/* 神策SDK：afterInteractive加载，完成后触发事件 */}
        <Script 
          strategy="afterInteractive" 
          src={"https://web.webstatic.cc/sensorsdata.min.js?v=" + Package.version}
          onLoad={() => {
            // 触发神策SDK加载完成事件
            if (typeof window !== 'undefined') {
              window.dispatchEvent(new Event('sensorsScriptLoaded'));
            }
          }}
        />
        {cdnConfig.getCdnLibScripts()}
        {/* Google Tag Manager */}
        <Script
          id="google-tag-manager"
          strategy="lazyOnload"
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${gtmId}');`,
          }}
        />
        {/* End Google Tag Manager */}
        {/* <Seo tdk={pageProps.tdk} lang={pageProps.locale} resolvedUrl={pageProps.resolvedUrl} Head={Head} /> */}
        {/* eslint-disable */}
        <Script
          id="app-before-interactive"
          data-theme={pageProps.theme}
          strategy="beforeInteractive"
          src={domain + "/beforeInteractive.js?v=" + Package.version}
        />
        <Script strategy="lazyOnload" src={domain + "/iconpark.js?v=" + Package.version} />
        {/* eslint-enable */}
        {/* ⚡ Iconfont 异步加载，不阻塞渲染 */}
        <Script 
          strategy="lazyOnload" 
          id="iconfont-css"
          dangerouslySetInnerHTML={{
            __html: `
              (function(){
                var loadFont = function(){
                  var link=document.createElement('link');
                  link.rel='stylesheet';
                  link.href='https://at.alicdn.com/t/font_2502537_ytndssfkiy.css';
                  link.media='print';
                  link.onload=function(){this.media='all'};
                  document.head.appendChild(link);
                };
                
                if('requestIdleCallback' in window){
                  requestIdleCallback(loadFont, {timeout:1000});
                } else {
                  setTimeout(loadFont, 100);
                }
              })();
            `
          }}
        />
        <Script strategy="lazyOnload" src="https://www.googletagmanager.com/gtag/js?id=G-ECW5SYQQJF"></Script>
        <Script
          strategy="lazyOnload"
          id="gtag-script"
          dangerouslySetInnerHTML={{
            __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'G-ECW5SYQQJF');
          `,
          }}
        ></Script>
        <Content {...pageProps}>
          <Component {...pageProps} />
        </Content>
      </ConfigProvider>
    </Provider>
  );
}

/* App.getInitialProps = async (context) => {
  Locale.init(context.router.locale, context.router.locales, langMessages);
  const { getTranslation } = Hooks;
  const t = getTranslation();
  const litHtml = await renderList({ _t: t });

  return {
    pageProps: {
      litHtml,
    },
  };
}; */

export default App;

export function reportWebVitals(metric) {
  const { pathname, route, locale } = (reportWebVitals as any).nextRouterInfo || {};
}

function generateNonceStr(length: number, type?: string) {
  let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  type === "num" && (chars = "0123456789");
  const maxPos = chars.length;
  let noceStr = "";
  for (let i = 0; i < (length || 32); i++) {
    noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return noceStr;
}

App.getInitialProps = async (context) => {
  const appProps = await NextApp.getInitialProps(context as any);
  const locale = (context as any)?.router?.locale || "en";
  const langMessages = await loadLocaleMessages(locale);

  return {
    ...appProps,
    pageProps: {
      ...(appProps?.pageProps || {}),
      langMessages,
    },
  } as any;
};
